import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Switch from "react-switch";

import { EndPoints } from "../../Helpers/Constants/EndPoints";
import Loader from "../Common/Loader";

import API from "../../Helpers/Constants/EndPoints/Api";
import Axios from "../../Helpers/Universal/Axios/Axios";
import {
  CreatedAt,
  timestampToHM,
} from "../../Helpers/Universal/Function/common";
import { NA, ATTENDANCE } from "../../Helpers/Constants/Default";
import PathLocator from "../Common/Map/PathLocator";
import DataNotFound from "../Common/DataNotFound";

const AttendanceSlot = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [showNotAttended, setShowNotAttended] = useState(false);
  const [visible, setVisible] = useState({
    loader: false,
    deleteConformation: { data: false, visible: false },
  });

  const getData = async () => {
    try {
      setVisible((prev) => ({ ...prev, loader: true }));
      const { status, data } = await Axios.get(API.AGENT.ATTENDANCE_SLOT, {
        attendanceId: state,
      });
      if (status) {
        const list = Array.isArray(data) ? data : [data];
        setAllData(list);
        setData(list.filter((i) => i.isAttendence));
      }
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible((prev) => ({ ...prev, loader: false }));
    }
  };

  const handleToggle = (checked) => {
    setShowNotAttended(checked);
    if (checked) {
      setData(allData.filter((item) => !item.isAttendence));
    } else {
      setData(allData.filter((i) => i.isAttendence));
    }
  };

  useEffect(() => {
    state ? getData() : navigate(EndPoints.AGENT);
  }, []);

  return (
    <>
      <div className="profile-view">
        <div className="map-right">
          <PathLocator data={data} />
        </div>

        {visible.loader && <Loader />}

        {/* 🔘 Toggle switch */}
        <div
          className="d-flex align-items-center mt-3 px-3 py-2 rounded"

        >
          {showNotAttended?    <span
            style={{
              marginRight: "10px",
              fontWeight: "500",
              color: "#333",
              backgroundColor: "#e3f2fd",
              padding: "2px 8px",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          >
            Background Location
          </span>:    <span
            style={{
              marginRight: "10px",
              fontWeight: "500",
              color: "#333",
              backgroundColor: "#e3f2fd",
              padding: "2px 8px",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          >
             Marked Location
          </span>}
      

          <Switch
            onChange={handleToggle}
            checked={showNotAttended}
            onColor="#f44336"
            offColor="#ccc"
            uncheckedIcon={false}
            checkedIcon={false}
            height={20}
            width={40}
          />
        </div>

        <div className="container-fluid">
          <div className="overflow-table">
            <table className="page-table">
              <thead>
                <tr>
                  <th scope="col" className="text-uppercase">
                    #
                  </th>
                  <th scope="col" className="text-uppercase">
                    Profile
                  </th>
                  <th scope="col" className="text-uppercase">
                    Marked Time
                  </th>
                  <th scope="col" className="text-uppercase">
                    Status
                  </th>
                  {!showNotAttended
                    ? ((
                        <th scope="col" className="text-uppercase">
                          Start Time
                        </th>
                      ),
                      (
                        <th scope="col" className="text-uppercase">
                          End Time
                        </th>
                      ))
                    : ""}
                  <th scope="col" className="text-uppercase">
                    Date
                  </th>
                </tr>
              </thead>
              {data?.length === 0 ? (
                <DataNotFound />
              ) : (
                <tbody>
                  {data.map((val, i) => (
                    <tr key={val._id}>
                      <td>{i + 1}</td>
                      <td>
                        {val.image ? (
                          <img
                            className="profile"
                            src={val.image}
                            alt={val.name}
                          />
                        ) : (
                          NA
                        )}
                      </td>
                      <td>{timestampToHM(val.markedTime)}</td>
                      <td>{ATTENDANCE.STATUS[val.status]}</td>
                      {!showNotAttended
                        ? ((<td>{timestampToHM(val.startTime)}</td>),
                          (<td>{timestampToHM(val.endTime)}</td>))
                        : ""}
                      <td>{CreatedAt(val.createdAt)}</td>
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceSlot;
